(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ye-creatine-listicle"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.ye-ll');
  if (!root) return;

  var bar = root.querySelector('[data-ye-sticky]');
  var hero = root.querySelector('[data-ye-hero]');
  var offer = root.querySelector('[data-ye-offer]');
  var foot = root.querySelector('[data-ye-foot]');
  if (bar && hero && 'IntersectionObserver' in window) {
    var seen = { hero: true, offer: false, foot: false };
    var update = function () { bar.hidden = seen.hero || seen.offer || seen.foot; };
    var watch = function (el, key, threshold) {
      if (!el) return;
      new IntersectionObserver(function (e) { seen[key] = e[0].isIntersecting; update(); }, { threshold: threshold }).observe(el);
    };
    watch(hero, 'hero', 0);
    watch(offer, 'offer', 0.15);
    watch(foot, 'foot', 0);
  }

  var dock = root.querySelector('[data-ye-dock]');
  if (dock) {
    var opener = dock.querySelector('[data-ye-dock-open]');
    var closeBtn = dock.querySelector('.ye-dock-x');
    var setOpen = function (open, how) {
      dock.setAttribute('data-open', open ? 'true' : 'false');
      opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        (window.dataLayer = window.dataLayer || []).push({ event: 'ye_listicle_dock_open', cta_location: how || 'peek', offer_position: 'sticky', compact_copy: root.getAttribute('data-ye-compact') });
        window.requestAnimationFrame(function () { closeBtn.focus({ preventScroll: true }); });
      } else {
        opener.focus({ preventScroll: true });
      }
    };
    var isOpen = function () { return dock.getAttribute('data-open') === 'true'; };
    var inline = root.querySelector('[data-ye-offer-inline]');
    if (inline && 'IntersectionObserver' in window) {
      var io = null;
      var watchInline = function () {
        var h = Math.round(opener.getBoundingClientRect().height) || 88;
        if (io) io.disconnect();
        io = new IntersectionObserver(function (e) {
          var en = e[0];
          dock.setAttribute('data-away', (en.isIntersecting || en.boundingClientRect.top < 0) ? 'true' : 'false');
        }, { rootMargin: '0px 0px -' + h + 'px 0px', threshold: 0 });
        io.observe(inline);
      };
      watchInline();
      window.addEventListener('resize', watchInline);
    }
    opener.addEventListener('click', function () { setOpen(true, 'peek'); });
    dock.querySelectorAll('[data-ye-dock-close]').forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) setOpen(false); });
    root.querySelectorAll('a[href="#ye-offer"]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); setOpen(true, 'hero-jump'); });
    });
  }

  root.querySelectorAll('[data-ye-reel]').forEach(function (reel) {
    var scroller = reel.querySelector('[data-ye-reel-scroller]');
    var prev = reel.querySelector('[data-ye-reel-prev]');
    var next = reel.querySelector('[data-ye-reel-next]');
    var sync = function () {
      var max = scroller.scrollWidth - scroller.clientWidth;
      prev.hidden = scroller.scrollLeft <= 4;
      next.hidden = max <= 4 || scroller.scrollLeft >= max - 4;
    };
    var step = function (dir) { scroller.scrollBy({ left: dir * Math.max(200, scroller.clientWidth * 0.8), behavior: 'smooth' }); };
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    scroller.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    reel.querySelectorAll('[data-ye-reel-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stage = btn.closest('[data-ye-reel-stage]');
        reel.querySelectorAll('video').forEach(function (v) { v.pause(); });
        var v = stage.querySelector('video');
        if (!v) {
          v = document.createElement('video');
          v.src = stage.getAttribute('data-src');
          v.controls = true;
          v.autoplay = true;
          v.preload = 'auto';
          v.setAttribute('playsinline', '');
          stage.appendChild(v);
          (window.dataLayer = window.dataLayer || []).push({ event: 'ye_listicle_video_play', video_index: Number(stage.getAttribute('data-index')), offer_position: root.getAttribute('data-ye-offer-pos') });
        } else { v.play(); }
        btn.hidden = true;
      });
    });
  });

  [].slice.call(root.querySelectorAll('[data-ye-tabs]')).forEach(function (box) {
    var tabs = [].slice.call(box.querySelectorAll('[role="tab"]'));
    function show(tab, focus) {
      tabs.forEach(function (x) {
        var on = x === tab;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(x.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { show(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
        if (n === null) return;
        e.preventDefault();
        show(tabs[(n + tabs.length) % tabs.length], true);
      });
    });
  });

  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ye-cta]');
    if (!a) return;
    (window.dataLayer = window.dataLayer || []).push({ event: 'ye_listicle_cta_click', cta_location: a.getAttribute('data-ye-cta'), offer_position: root.getAttribute('data-ye-offer-pos'), compact_copy: root.getAttribute('data-ye-compact') });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
